import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import locationIcon from "../photo/location.png";
import { useSelector } from "react-redux";
import { Navbar } from "./navbar";
import "../styles/infoProjets.css";

// Simplified InteractiveMap for Info View using Leaflet loaded dynamically via CDN
function InteractiveMap({ initialLocation }) {
    const mapRef = useRef(null);
    const mapInstanceRef = useRef(null);
    const markerRef = useRef(null);
    const [leafletLoaded, setLeafletLoaded] = useState(false);

    useEffect(() => {
        if (window.L) {
            setLeafletLoaded(true);
            return;
        }

        if (!document.getElementById('leaflet-css')) {
            const link = document.createElement('link');
            link.id = 'leaflet-css';
            link.rel = 'stylesheet';
            link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
            document.head.appendChild(link);
        }

        if (!document.getElementById('leaflet-js')) {
            const script = document.createElement('script');
            script.id = 'leaflet-js';
            script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
            script.async = true;
            script.onload = () => setLeafletLoaded(true);
            document.head.appendChild(script);
        } else {
            const interval = setInterval(() => {
                if (window.L) {
                    setLeafletLoaded(true);
                    clearInterval(interval);
                }
            }, 100);
            return () => clearInterval(interval);
        }
    }, []);

    useEffect(() => {
        if (!leafletLoaded || !mapRef.current || mapInstanceRef.current || !window.L) return;

        const L = window.L;
        const lat = parseFloat(initialLocation?.lat) || 33.5892;
        const lng = parseFloat(initialLocation?.lng) || -7.6031;

        const map = L.map(mapRef.current, {
            zoomControl: false,
            attributionControl: false
        }).setView([lat, lng], 15);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(map);
        mapInstanceRef.current = map;

        const icon = L.divIcon({ 
            className: '', 
            html: `<div style="background:#8B0000;width:28px;height:28px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:3px solid white;box-shadow:0 4px 10px rgba(0,0,0,0.3)"></div>`, 
            iconSize: [28, 28], 
            iconAnchor: [14, 28] 
        });
        markerRef.current = L.marker([lat, lng], { icon }).addTo(map);

        return () => {
            if (mapInstanceRef.current) {
                mapInstanceRef.current.remove();
                mapInstanceRef.current = null;
            }
        };
    }, [leafletLoaded, initialLocation]);

    return <div ref={mapRef} style={{ width: '100%', height: '100%', borderRadius: '12px' }} />;
}

export function InfoProjet() {
    const { id } = useParams();
    const listP = useSelector(s => s.listP) || [];
    const Projet = listP.find(a => a.id == id);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!location.state?.fromList) {
            navigate('/listeProjets', { replace: true });
        }
    }, [location.state, navigate]);

    if (!Projet) return null;

    const handleClose = () => navigate(-1);

    return (
        <div className="projet-detail-page">
            <Navbar />

            <div className="projet-content-wrapper">
                <button className="back-link" onClick={handleClose} style={{ background: 'none', border: 'none', cursor: 'pointer', marginTop: '20px', marginLeft: '20px' }}><span>←</span> Retour aux projets</button>

                <div className="info-projet-container">
                    <img
                        src={Projet.imageProjet || ''} 
                        alt={Projet.nomProjet}
                        className="project-hero-img"
                    />

                    <div className="project-inner-body">
                        <p className="project-title-top">{Projet.nomProjet}</p>

                        <div className="project-info-grid">
                            {/* Left Card: Project Info */}
                            <div className="info-card">
                                <h5>Informations du projet</h5>
                                <table className="info-table">
                                    <tbody>
                                        <tr>
                                            <td>Client:</td>
                                            <td>{Projet.societeConception}</td>
                                        </tr>
                                        <tr>
                                            <td>Partenaire:</td>
                                            <td>{Projet.societeRéalisation}</td>
                                        </tr>
                                        <tr>
                                            <td>Date:</td>
                                            <td>{Projet.annee}</td>
                                        </tr>
                                        <tr>
                                            <td>Surface:</td>
                                            <td>{Projet.surface}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            {/* Right Card: Location */}
                            <div className="info-card">
                                <h5>Localisation</h5>
                                <div className="location-header">
                                    <img src={locationIcon} alt="location" />
                                    <span>{Projet.location}</span>
                                </div>
                                <div className="google-map-wrapper">
                                    <InteractiveMap 
                                        initialLocation={Projet.coordonnees}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Bottom Card: Description */}
                        <div className="description-card">
                            <h5>Description</h5>
                            <p>{Projet.description}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
